import { FC, ReactNode } from 'react';

import { GridWrapper } from './Grid.styled';

interface GridWrapperProps {
  display?: 'grid' | 'inline-grid';
  gridTemplateColumns?: string;
  gridTemplateRows?: string;
  gap?: string;
  justifyContent?:
    | 'start'
    | 'end'
    | 'center'
    | 'stretch'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'normal';
  itemAlign?: 'start' | 'end' | 'center' | 'stretch' | 'baseline';
  margin?: string;
  children: ReactNode;
  contain?: boolean;
  height?: string;
  maxWidth?: string;
}
export const Grid: FC<GridWrapperProps> = ({
  children,
  display,
  gridTemplateColumns,
  gridTemplateRows,
  gap,
  justifyContent,
  itemAlign,
  margin,
  contain,
  height,
  maxWidth,
}) => (
  <GridWrapper
    display={display}
    gridColumns={gridTemplateColumns}
    gridTemplateRows={gridTemplateRows}
    gap={gap}
    justifyContent={justifyContent}
    itemAlign={itemAlign}
    margin={margin}
    contain={contain}
    height={height}
    maxWidth={maxWidth}
  >
    {children}
  </GridWrapper>
);
